module.exports = __webpack_public_path__ + "static/media/kid14.8f902818.png";